
import React from "react";

import { Container }  from "./Container";



export const Benefits = (props) => {
  const { data } = props;

  return (
      <Container className="flex flex-wrap mb-20 lg:gap-10 lg:flex-nowrap p-8">
        <div
          className={`flex items-center justify-center w-full lg:w-1/2 ${
            props.data.imgPos === "right" ? "lg:order-1" : ""
          }`}>
          <div
            className={`w-full max-w-[38rem] ${
              data.imageFrame === false
                ? ""
                : "rounded-[36px] bg-gradient-to-br from-[#f8fcf8] via-white to-[#edf7ee] p-4 lg:rounded-[48px] lg:p-5"
            }`}
          >
            <img
              loading="lazy"
              src={data.image}
              width={521}
              height={521}
              alt="Benefits"
              className={`object-cover ${
                data.imageFrame === false
                  ? "rounded-none"
                  : "rounded-[30px] lg:rounded-[42px]"
              }`}
              placeholder="blur"
             
            />
          </div>
        </div>

        <div
          className={`flex flex-wrap items-center w-full lg:w-1/2 ${
            data.imgPos === "right" ? "lg:justify-end" : ""
          }`}>
          <div>
            <div className="flex flex-col w-full mt-4">
              <h3 className="max-w-2xl mt-3 text-3xl font-bold leading-snug tracking-tight text-gray-800 lg:leading-tight lg:text-4xl dark:text-white">
                {data.title}
              </h3>

              <p className="max-w-2xl py-4 text-lg leading-normal text-gray-500 lg:text-xl xl:text-xl dark:text-gray-300 white-space: pre-wrap">
                {data.desc}
                <br></br>
                {data.desc2}
              </p>
              <p className="max-w-2xl py-4 text-lg leading-normal text-gray-500 lg:text-xl xl:text-xl dark:text-gray-300 white-space: pre-wrap">
                {data.desc3}
              </p>
            </div>

            <div className="w-full mt-5">
              {data.bullets.map((item, index) => (
                <Benefit key={index} title={item.title} icon={item.icon}>
                  {item.desc}
                </Benefit>
              ))}
            </div>
          </div>
        </div>
      </Container>
  );
};

function Benefit(props) {
  return (
      <div className="flex items-start mt-8 space-x-3">
        <div className="flex items-center justify-center flex-shrink-0 mt-1 bg-green-400 rounded-md w-11 h-11 ">
          {React.cloneElement(props.icon, {
            className: "w-7 h-7 text-green-50",
          })}
        </div>
        <div>
          <h4 className="text-xl font-medium text-gray-800 dark:text-gray-200">
            {props.title}
          </h4>
          <p className="mt-1 text-gray-500 dark:text-gray-400">
            {props.children}
          </p>
        </div>
      </div>
  );
}
